<div class="row">
	<div class="col-lg-10 offset-lg-1 col-12 jmDashTitle">
		<div class="row">
			<div class="col-12 jmNoPaddingCol">
				<div class="jmDashTitleBlock">&nbsp;</div>
			</div>
			<div class="col-12">
				<app-navigation-history></app-navigation-history>
			</div>
		</div>
	</div>
</div>

<div *ngIf="status===0"  class="text-center" style="height:800px; margin-top:8%;">
	<span class="fa jmWidgetLoadingIcon"></span>
</div>

<div *ngIf="status===1" style="margin-top:10px; margin-bottom:50px;">
	<gridster [options]="gridsterOptions" class="jmGridster" [appGridsterLazyLoad]="gstItems">
		<gridster-item id="giDescription" [item]="descriptionDimensions" class="jmGridsterItem">
			<app-college-scorecard-description class="h-100" [objectId]="schoolId" [objectName]="objectTitle" [objectIcon]="iconImage" [coverImg]="school.SchoolBackgroundImage" [objectUrl]="objectURL"></app-college-scorecard-description>
		</gridster-item>
		<gridster-item id="giAtGlance" [item]="atAGlanceDimensions" class="jmGridsterItem">
			<app-college-scorecard-at-a-glance [iconList]="atAGlanceData"></app-college-scorecard-at-a-glance>
		</gridster-item>
		<gridster-item id="giMap" [item]="googleMapDimensions" class="jmGridsterItem">
			<app-google-map class="h-100 jmWidgetRoundCorners" [title]="school.Name" [subtitle]="gMapSubTitle" [loc]="school.Location"></app-google-map>
		</gridster-item>
		<gridster-item id="giProgram" [item]="academicProgDimensions" class="jmGridsterItem">
			<app-college-scorecard-fields-of-study *ngIf="gstItems.giProgram" [schoolId]="schoolId"></app-college-scorecard-fields-of-study>
		</gridster-item>
		<gridster-item id="giTestScores" [item]="testScoreDimensions" class="jmGridsterItem">
			<app-college-scorecard-test-score *ngIf="gstItems.giTestScores" [data]="testScores"></app-college-scorecard-test-score>
		</gridster-item>
		<gridster-item id="giGraduationRetention" [item]="gradDimensions" class="jmGridsterItem">
			<app-college-scorecard-graduate *ngIf="gstItems.giGraduationRetention" [data]="school.UIDt.GR"></app-college-scorecard-graduate>
		</gridster-item>
		<gridster-item id="giCost" [item]="costDimensions" class="jmGridsterItem">
			<app-college-scorecard-cost *ngIf="gstItems.giCost" [data]="school.UIDt.Cost"></app-college-scorecard-cost>
		</gridster-item>
		<gridster-item id="giFinancialAidDebt" [item]="financeDimensions" class="jmGridsterItem">
			<app-college-scorecard-financial-aid *ngIf="gstItems.giFinancialAidDebt" [data]="school.UIDt.Aid"></app-college-scorecard-financial-aid>
		</gridster-item>
		<gridster-item id="giEarningsAfterSchool" [item]="earningDimensions" class="jmGridsterItem">
			<app-college-scorecard-earning-after-school *ngIf="gstItems.giEarningsAfterSchool" [data]="school.UIDt.EAS"></app-college-scorecard-earning-after-school>
		</gridster-item>
	</gridster>
</div>

<div *ngIf="status===2" class="row " style="margin-top:20px;margin-bottom:50px">
	<div class="border col-lg-10 offset-lg-1 col-12" style="background-color:#29BCA3;">
		<table style="table-layout:fixed; width:100%; color:white;">
			<tr>
				<td style="text-align:center; vertical-align:middle; width:200px;"><img src="assets/images/DidThatJustHappen.png" /></td>
				<td style="padding-top:20px;">
					<div style="font-size:40px;">Did that just happen?!</div>
					<div style="font-size:25px;">This school is no longer found in College Scorecard.</div>
				</td>
			</tr>
		</table>
	</div>
</div>
